import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from '../services/data-sharing.service';
import { CommonDataService } from '../services/common-data.service';
import { Month } from '../models/month';
import { Year } from '../models/year';

@Component({
  selector: 'payment-online-class',
  templateUrl: './payment-online-class.component.html',
  styleUrls: ['./payment-online-class.component.css']
})
export class PaymentOnlineClassComponent implements OnInit {
 
  months: Month[] = [];
  selectedMonth: Month = new Month;
  years: Year[] = [];
  selectedYear: Year = new Year;

  constructor(
    private _router: Router,
    private _dataService: DataSharingService,
    private _commonService: CommonDataService
  ) {
    
  }

  submit() {
    this._dataService.setRegisterOnlineProgress('2');
    this._router.navigate(['payment-confirmation-online-class']);
  }

  getMonths() {
    this._commonService.getMonths()
      .subscribe(
      months => this.setMonths(months),
      error => console.log('Error: ' + error),
      () => console.log('Completed!'));
  }

  setMonths(months: any) {
    this.months = months;
    let defaultMonth = {
      id: '-1',
      number: '-1',
      name: 'month',
      abbr: 'month'      
    };

    this.months[0] = defaultMonth;
    this.selectedMonth = this.months[0];
  }

  getYears() {
    this._commonService.getYearRange(7)
      .subscribe(
      years => this.setYears(years),
      error => console.log('Error: ' + error),
      () => console.log('Completed!'));
  }

  setYears(years: any) {
    this.years = years;
    let defaultYear = {
      year: 'year'
    };
    this.years[0] = defaultYear;
    this.selectedYear = this.years[0];
  }

  expirationDateChanged(event: any) {
    this.selectedMonth = event.value;
    console.log('month changed'); //working
  }


  ngOnInit() {
    //Get months
    this.getMonths();

    //Get Years
    this.getYears();
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-online-class/payment-online-class.component.ts